import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { API_SERVER_URL, V3_APP_BASE_URL } from '@/constants/Config';

export const topbarDataQuery = createApi({
  reducerPath: 'topbarDataQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  tagTypes: ['Chapters', 'topChapters'],
  endpoints: (build) => ({
    getTopBarData: build.query({
      query: () => ({
        url: `${API_SERVER_URL}api/filters/getTopBarData`,
        method: 'get',
      }),
      providesTags: ['topChapters'],
    }),
  }),
});

export const { useGetTopBarDataQuery } = topbarDataQuery;
